import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export function BackToMenuButton() {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 left-8 z-50 flex items-center gap-2 bg-primary hover:bg-primary-dark text-white px-4 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 group"
      aria-label={language === 'es' ? 'Volver al menú principal' : 'Back to main menu'}
    >
      <ChevronUp className="h-5 w-5 transition-transform group-hover:-translate-y-1" />
      <span>{language === 'es' ? 'Menú Principal' : 'Main Menu'}</span>
    </button>
  );
}